import { render, staticRenderFns } from "./MultipleTextInput.vue?vue&type=template&id=1271949a&"
import script from "./MultipleTextInput.vue?vue&type=script&lang=ts&"
export * from "./MultipleTextInput.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports